import { render } from "./ContactDetailsJobsTab.vue?vue&type=template&id=63625410"
import script from "./ContactDetailsJobsTab.vue?vue&type=script&lang=js"
export * from "./ContactDetailsJobsTab.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__